import React, { Component, Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Modal, Button, Image } from "react-bootstrap";
import moment from "moment";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import {
  Select,
  MenuItem,
  InputLabel,
  TextField,
  FormControl,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import CustomerEditModel from "./CustomerEditModel";
import { connect } from "react-redux";
import { withRouter, useHistory, Redirect } from "react-router-dom";
import CarouselMain from "./CarouselMain";
import {
  create_order_vedor_side,
  razor_pay_create_order,
  razor_payment,
  edit_order_vendor_side_payment,
  apply_offer_code,
  editTransaction,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  SET_ORDER_DONATION,
  SET_ORDER_TIP,
  UPDATE_CART_FILTERED_MENU_ORDER,
  SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
  APPLY_OFFER_VENDOR,
  SET_VENDOR_ORDERING_CART_DATA,
  CREATE_ORDER_VENDOR,
} from "../../../../store/types";
import store from "../../../../store/store";
import Alert from "react-s-alert";
import {
  CLEAR_CART_DATA,
  CLEAR_CART_DATA_USER_DATA,
} from "../../../../store/types";
import VendorLearnMore from "../../../reusableComponents/allPopupReusable/learnMorePopup/VendorLearnMore";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import isEmpty from "../../../../store/validation/is-Empty";
import { ORDER_RAZORPAY_KEY, serverApi } from "../../../../config/Keys";
import axios from "axios";
import Media from "react-media";
import { getFlatCharges } from "../../../../function/getFlatCharges";
import { DELIVERY_TYPES, FLAT_CHARGE_KEYS } from "../../../../enums/OrderEnums";
import { DEFAULT_ITEM_IMAGE } from "../../../../enums/GlobalEnums";
import { NOTAVAILABLEIMAGE } from "../../../../enums/GlobalEnums";
import {
  ITEMTYPEVEG,
  INCASEOFUNAVAILABILITY,
  ORDER_TYPE_NAME,
} from "../../../../enums/OrderEnums";
import InfoToolTip from "../../../reusableComponents/InfoTooltipComponent";
import MinAmountModal from "../../../reusableComponents/MinAmountModal";
import { errorAlert } from "../../../../function/alert";
import {
  calcDeliveryDiscount,
  calcDiscount,
  calcFinalTotal,
  calcTotalOriginal,
} from "../../../../function/ordering";

const optionsImage = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%",
    border: "0.5px solid #9E9E9E;",
    borderRadius: "5px",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

class RightComponentOrderRequest extends Component {
  state = {
    error: {},
    offerCodeData: {},
    tip: 0,
    tipAmount: 0,
    totalTipAmount: 0,
    donationId: 1,
    donationAmount: 2,
    totalDonationAmount: 2,
    open: false,
    openTract: false,
    total_amount: 2,
    total_charges: 0,
    onlinePayment: true,
    transactional_id: 0,
    orderId: 0,
    customButtonTip: false,
    customButtonTipText: "",
    customButtonDonate: false,
    customButtonDonateText: "",
    donationData: {
      amount: 2,
    },
    availableOffers: [],
    displayAvailableOffers: false,
    minAmountModal: false,

    inCaseUnAvailability: false,
    inCaseUnAvailabilityIndexValue: "",
    inCaseDropDownValue: "",
    inCaseNotes: "",
    summary: {},
  };
  //const dispatch = useDispatch();
  loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  };

  componentDidMount() {
    // if (!isEmpty(this.state.donationAmount)) {
    //   store.dispatch({
    //     type: SET_ORDER_DONATION,
    //     payload: this.state.donationData,
    //   });
    // }
    if (this.props.cart_data.length === 0) {
      store.dispatch({
        type: SET_ORDER_DONATION,
        payload: this.state.donationData,
      });
    }
    let summary = calcFinalTotal(
      this.props.cart_data,
      this.props.user_data,
      this.props.offerData,
      this.props.subscription
    );
    this.setState({ summary: summary });
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (!isEmpty(nextProps.offerData) !== nextState.availableOffers) {
      return {
        availableOffers: !isEmpty(nextProps.offerData)
          ? nextProps.offerData.filter(
            (offer) => offer.active === true && offer.isOnline === true
          )
          : [],
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.cart_data) !==
      JSON.stringify(prevProps.cart_data) ||
      JSON.stringify(this.props.user_data) !==
      JSON.stringify(prevProps.user_data)
    ) {
      let summary = calcFinalTotal(
        this.props.cart_data,
        this.props.user_data,
        this.props.offerData,
        this.props.subscription
      );
      this.setState({ summary: summary });
    }
  }

  // const __DEV__ = document.domain === "localhost";

  //const [name, setName] = useState("Mehul");

  async displayRazorpay(
    total,
    userId,
    name,
    phoneNo,
    email,
    orderId,
    allOrderData
  ) {
    const res = await this.loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const onSuccess = (data, orderId) => {
      this.setState({
        transactional_id: data.transactional._id,
        orderId: orderId,
      });

      const onSuccessHandler = (response) => {
        const formData = {
          razorpay_payment_id: response.razorpay_payment_id,
          transactional_id: data.transactional._id,
          isEvent: false,
          order_id: orderId,
          restaurant_id: this.props.onboarding._id,
          transaction_type: "RAZORPAY",
          user_id: userId,
          currency: "INR",
        };

        let orderData = {
          id: orderId,
          paid: true,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);

        if (
          allOrderData &&
          allOrderData.donation &&
          allOrderData.donation.amount
        ) {
          formData.donation = {};
          formData.donation.amount = allOrderData.donation.amount;
        }

        const token = this.props.auth.user.accessToken;
        this.props.razor_payment(
          token,
          formData,
          this.onSuccessCallFinalApi,
          orderId
        );

        Alert.success(`<h4>your order is successfully placed</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        this.props.history.push("/orderdashboard");
      };

      const onFailure = (response) => {
        const formData = {};
        //formData.transactional_id = data._id;
        formData.payment_status = 3;
        formData.transactional_id = data.transactional._id;
        formData.razorpay_payment_id = response.error.metadata.payment_id;
        const token = this.props.auth.user.accessToken;
        this.props.edit_order_vendor_side_payment(token, formData, orderId);

        let orderData = {
          id: orderId,
          paid: false,
          transactionId: data.transactional._id,
          txnId: data?.transactional?.transactionNumber,
          method: "RAZORPAY",
          amount: total,
          type: "PAYMENT",
          date: Date.now(),
          paymentType: allOrderData?.payment_method,
        };
        this.props.editTransaction(orderData);

        Alert.error(`<h4>Unable to process the order</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        this.props.history.push("/orderdashboard");
      };

      const options = {
        //key: __DEV__ ? "rzp_test_7P1z0w07gah1Uv" : "PRODUCTION_KEY",
        key: ORDER_RAZORPAY_KEY,
        currency: data.currency,
        amount: data.amount.toString(),
        order_id: data.id,
        name: "Amealio",
        description: "Amealio Ordering Payment",
        method: {
          netbanking: false,
          card: true,
          wallet: false,
          upi: false,
        },
        // config: {
        //   hide: [
        //     {
        //       method: "upi",
        //     },
        //   ],
        // },
        //image: "http://localhost:1337/logo.svg",
        handler: function (response) {
          // alert(response.razorpay_payment_id);
          // alert(response.razorpay_order_id);
          // alert(response.razorpay_signature);

          // const formData = {
          //   razorpay_payment_id: response.razorpay_payment_id,
          //   transactional_id: this.state.transactional_id,
          //   isEvent: false,
          // };
          // this.props.razor_payment(
          //   this.state.token,
          //   formData,
          //   this.onSuccessCallFinalApi
          // );
          onSuccessHandler(response);
        },
        prefill: {
          name: name,
          email: email,
          contact: phoneNo,
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
      paymentObject.on("payment.failed", function (response) {
        onFailure(response);
        // alert(response.error.code);
        // alert(response.error.description);
        // alert(response.error.source);
        // alert(response.error.step);
        // alert(response.error.reason);
        // alert(response.error.metadata.order_id);
        // alert(response.error.metadata.payment_id);
      });
    };

    const formData = {
      amount: parseFloat(total).toFixed(2),
      user_id: userId,
      refModel: "User",
      message: "Order Payment",
      currency: "INR",
      isEvent: false,
      receipt: orderId,
      orderId: orderId,
      restaurant_id: this.props.onboarding._id,
      transaction_type: "RAZORPAY",
    };
    //formData = { donation: {} };
    // if (data && data.donation && data.donation.amount) {
    //   formData.donation = {};
    //   formData.donation.amount = data.donation.amount;
    // }

    const token = this.props.auth.user.accessToken;
    this.setState({ token: token });
    this.props.razor_pay_create_order(token, formData, onSuccess, orderId);

    // const data = await fetch("http://localhost:1337/razorpay", {
    //   method: "POST",
    // }).then((t) => t.json());
  }

  orderSuccess = (data, orderId) => {
    if (
      data.payment_method === 0 ||
      data.payment_method === 6 ||
      data.payment_method === 7 ||
      data.payment_method === 8 ||
      data.payment_method === 9
    ) {
      let orderData = {
        id: orderId,
        paid: data?.payment_method === 6 ? false : true,
        method: data?.payment_method === 6 ? "PAYLATER" : "EXTERNAL",
        amount: data.total_amount,
        type: data?.payment_method === 6 ? "PAYLATER" : "PAYMENT",
        date: Date.now(),
        paymentType: data?.payment_method,
      };
      if (data.payment_method === 8) {
        orderData.transactionRef = this.props.user_data.walletDetails;
      }
      this.props.editTransaction(orderData);
      // cash
      //this.setState({ open: true });
      // alert("ORDER CREATED");
      this.props.setShow();
      this.props.setData(data);
      //this.onUpdateOrder(data, orderId);
      Alert.success(`<h4>Order Created  Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      // store.dispatch({
      //   type: CLEAR_CART_DATA,
      //   //payload: formData,
      // });
      // store.dispatch({
      //   type: CLEAR_CART_DATA_USER_DATA,
      //   //payload: formData,
      // });
      this.props.history.push("/orderdashboard");
    } else {
      this.displayRazorpay(
        data.total_amount,
        data.user_details.userId,
        data.user_details.first_name,
        data.user_details.mobile_number,
        data.user_details.email,
        orderId,
        data
      );
    }
  };

  setOpenTract = () => {
    this.setState({ open: false, openTract: true });
  };

  prepareAddOn = (data) => {
    let addOnsNames = [];
    // for (let i = 0; i < data.length; i++) {
    //   for (let j = 0; j < data[i].options.length; j++) {
    //     addOnsNames.push(data[i].options[j].name);
    //   }
    // }
    // return addOnsNames.toString();
    for (let i = 0; i < data.length; i++) {
      for (let j = 0; j < data[i].options.length; j++) {
        let addData = {};
        addData = data[i].options[j];
        addOnsNames.push(addData);
      }
    }
    let newArray = [];
    if (addOnsNames.length > 0) {
      let uniqueObject = {};
      for (let i in addOnsNames) {
        let objTitle = addOnsNames[i]["_id"];
        uniqueObject[objTitle] = addOnsNames[i];
      }
      for (let i in uniqueObject) {
        newArray.push(uniqueObject[i]);
      }
    }
    return newArray;
  };

  onError = (err) => {
    err
      ? Alert.error(`<h4>Unable to process the order, ${err}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      })
      : Alert.success(`<h4>your order is successfully placed</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    this.props.history.push("/orderdashboard");
    return <Redirect to="/orderdashboard" />;
  };

  calcCharges = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let deliveryDiscount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
      itemPrice.push(data[i][0].finalPrice * data[i][0].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      if (this.props?.user_data?.type !== 'DELIVERY') {
        let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
        itemPrice.forEach((e) => {
          percent.push(((e / totalPrice) * 100).toFixed(2));
        });
        if (this.props.user_data?.isPercentage) {
          let offerDiscount = this.props.offerData.find(
            (e) => e.coupon_code === this.props?.user_data?.coupon_code
          );
          let totalPercentage = (
            (totalPrice * this.props?.user_data?.discountAmount) /
            100
          ).toFixed(2);
          if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
            discount = offerDiscount?.maximum_discount_applied;
          } else {
            discount = totalPercentage;
          }
          price = totalPrice - discount;
        } else {
          discount = this.props?.user_data?.discountAmount;
          price = totalPrice - discount;
        }
      } else {
        if (this?.props?.user_data?.deliveryMinOrder <= calcTotalOriginal(this.props.cart_data)) {
          deliveryDiscount = this.props?.user_data?.deliveryCharges?.user - this?.props?.user_data?.deliveryMaxDiscount > 0 ? this?.props?.user_data?.deliveryMaxDiscount : this.props?.user_data?.deliveryCharges?.user;
        }
      }
    }
    percent.forEach((e) => {
      discountValues.push(parseFloat((discount * e) / 100).toFixed(2));
    });

    let finalCharge = 0;
    for (let i = 0; i < data.length; i++) {
      let chargePercentage = 0;
      let chargeValue = 0;
      for (let j = 0; j < data[i][0].sur_charges.length; j++) {
        if (data[i][0].sur_charges[j].flag === "PERCENTAGE") {
          chargePercentage += parseFloat(data[i][0].sur_charges[j].value);
        } else {
          chargeValue +=
            parseFloat(data[i][0].sur_charges[j].value) * data[i][0].quantity;
        }
      }
      if (chargePercentage)
        finalCharge +=
          ((itemPrice[i] - parseFloat(discountValues[i] || 0)) *
            chargePercentage) /
          100;
      if (chargeValue) finalCharge += chargeValue;
    }
    if (deliveryDiscount) {
      finalCharge -= deliveryDiscount
    };
    return finalCharge.toFixed(2);
  };

  calcSurCharges = (data) => {
    let itemPrice = [];
    let check = [];
    let price = 0;
    let flatCharges = getFlatCharges(
      this.props?.subscription,
      this.props?.user_data?.order_type
    );
    for (let i = 0; i < data.length; i++) {
      price = data[i][0].finalPrice * data[i][0].quantity + price;
      itemPrice.push(data[i][0].finalPrice * data[i][0].quantity);
      for (let charge of data[i][0].sur_charges) {
        if (
          flatCharges.keys.length &&
          flatCharges.keys.includes(
            charge.code || charge.name?.split("-")[0].trim()
          )
        ) {
          check[i] = true;
        }
      }
    }
    if (check.length === data.length) {
      return 0;
    }
    return (flatCharges.value + (flatCharges.percentage * price) / 100).toFixed(
      2
    );
  };


  setTips = (tipId, tipValue) => {
    this.setState({ tip: tipId, tipAmount: tipValue });
    let data = { ...this.props.user_data };
    data.tip = { value: tipId, amount: tipValue };
    store.dispatch({ type: CREATE_ORDER_VENDOR, payload: data });
    // this.props.addTips(calcTips);
  };

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  onHandleChange = (e) => {
    const { value, maxLength } = e.target;
    const number = value.slice(0, maxLength);
    this.setState({
      [e.target.name]: number,
      errors: {},
    });
  };

  onCustomTipAccount = () => {
    this.setState({
      customButtonTip: true,
    });
  };

  onClickSaveCustomButtonTips = () => {
    let tipData = tips;
    let tipDataId = tipData[tipData.length - 1];
    let inputData = this.state.customButtonTipText;
    let makingData = {
      id: "",
      amount: "",
    };
    if (inputData === "") {
      Alert.error(`<h4>Please Enter Tip Amount</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      if (tips.some((tip) => tip.amount === parseInt(inputData))) {
        Alert.error(`<h4>Tip Amount Already Exits</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        makingData = {
          id: tipDataId.id + 1,
          amount: parseInt(inputData),
        };
        // tipData.push(makingData);
        this.setState({ customButtonTipText: "" });
        this.setTips(makingData.id, makingData.amount);
      }
    }
  };

  onCustomTipDiscountAccount = () => {
    this.setState({
      customButtonDonate: true,
    });
  };

  onClickSaveCustomButtonDonate = () => {
    let donatesData = donates;
    let donatesDataId = donatesData[donatesData.length - 1];
    let inputData = this.state.customButtonDonateText;
    let makingData = {
      id: "",
      amount: "",
    };
    if (inputData === "") {
      Alert.error(`<h4>Please Enter Donate Amount</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else if (inputData > 50) {
      Alert.error(`<h4>You can not donate more than 50rs.</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3500,
        offset: 35,
      });
    } else {
      if (donates.some((donate) => donate.amount === parseInt(inputData))) {
        Alert.error(`<h4>Donate Amount Already Exist</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        makingData = {
          id: donatesDataId.id + 1,
          amount: parseInt(inputData),
        };
        // donatesData.push(makingData);
        this.setState({ customButtonDonateText: "" });
        this.setDonation(makingData.id, makingData.amount);
      }
    }
  };

  setDonation = (donId, donAmount) => {
    this.setState({ donationId: donId, donationAmount: donAmount });
    let data = { ...this.props.user_data };
    data.donation = { value: donId, amount: donAmount };
    store.dispatch({ type: CREATE_ORDER_VENDOR, payload: data });
  };

  onUpdateOrder = (data, orderId) => {
    const formData = { donation: {} };
    if (data && data.donation && data.donation.amount) {
      formData.donation.amount = data.donation.amount;
      formData.donation.order_id = orderId;
      const token = this.props.auth.user.accessToken;
      this.props.edit_order_vendor_side_payment(
        token,
        formData,
        orderId,
        this.onSuccessPayment
      );
    } else {
      this.onSuccessPayment();
    }
  };

  onSuccess = (data, orderId) => {
    if (
      data.payment_method === 0 ||
      data.payment_method === 6 ||
      data.payment_method === 7
    ) {
      // cash
      //this.setState({ open: true });
      // alert("ORDER CREATED");
      this.props.setShow();
      this.props.setData(data);
      //this.onUpdateOrder(data, orderId);
      Alert.success(`<h4>Order Created  Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      // store.dispatch({
      //   type: CLEAR_CART_DATA,
      //   //payload: formData,
      // });
      // store.dispatch({
      //   type: CLEAR_CART_DATA_USER_DATA,
      //   //payload: formData,
      // });
      this.props.history.push("/orderdashboard");
    } else {
      this.displayRazorpay(
        data.total_amount,
        data.user_details.userId,
        data.user_details.first_name,
        data.user_details.mobile_number,
        data.user_details.email,
        orderId,
        data
      );
    }
    //this.props.history.push("/orderdashboard");
  };

  onSuccessPayment = (data) => {
    this.props.setShow();
    this.props.setData(data);

    // Alert.success(`<h4>Order Created  Successfully</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    // store.dispatch({
    //   type: CLEAR_CART_DATA,
    //   //payload: formData,
    // });
    // store.dispatch({
    //   type: CLEAR_CART_DATA_USER_DATA,
    //   //payload: formData,
    // });
    // this.props.history.push("/orderdashboard");
    this.setState({
      open: true,
    });
  };

  checkAvailability = async () => {
    let ids = [];
    this.props.cart_data.map((i) => ids.push(i[0].item.id));
    const response = await axios.post(`${serverApi}/order-availability`, {
      itemId: ids,
    });
    if (response.data.length > 0) {
      alert("Some items are sold out and removed from the cart.");
      let idsToVerify = [];
      this.props.cart_data.map((i) => idsToVerify.push(i[0].item.id));
      // _id
      let responseIds = [];
      response.data.map((i) => responseIds.push(i._id));
      await this.props.cart_data.map(async (i, index) => {
        if (responseIds.includes(i[0].item.id)) {
          await this.decrementHandler(i[0].itemId, i[0].quantity, index);
        }
      });
      setTimeout(() => {
        this.props.history.push("/orderpayment");
      }, 2000);
    } else {
      this.props.history.push("/orderpayment");
    }
  };

  getDiscountPrice = (data) => {
    let itemPrice = [];
    let price = 0;
    let percent = [];
    let discount = 0;
    let discountValues = [];
    for (let i = 0; i < data.length; i++) {
      price = data[i].finalPrice * data[i].quantity + price;
      itemPrice.push(data[i].finalPrice * data[i].quantity);
    }
    if (this.props.user_data?.isOfferApplied) {
      let totalPrice = itemPrice.reduce((pV, cV) => pV + cV);
      itemPrice.forEach((e) => {
        percent.push(((e / totalPrice) * 100).toFixed(2));
      });
      if (this.props.user_data?.isPercentage) {
        let offerDiscount = this.props.offerData.find(
          (e) => e.coupon_code === this.props?.user_data?.coupon_code
        );
        let totalPercentage = (
          (totalPrice * this.props?.user_data?.discountAmount) /
          100
        ).toFixed(2);
        if (totalPercentage >= offerDiscount?.maximum_discount_applied) {
          discount = offerDiscount?.maximum_discount_applied;
        } else {
          discount = totalPercentage;
        }
        price = totalPrice - discount;
      } else {
        discount = this.props?.user_data?.discountAmount;
        price = totalPrice - discount;
      }
      percent.forEach((e) => {
        discountValues.push(
          parseFloat(parseFloat((discount * e) / 100).toFixed(2))
        );
      });
      discountValues = discountValues.map((e, i) => itemPrice[i] - e);
    } else {
      discountValues = itemPrice;
    }

    return discountValues;
  };

  onSuccessCallFinalApi = (data, orderId) => {
    this.setState({ transactional_id: data._id, onlinePayment: false });
    const formData = {};
    formData.transactional_id = data._id;
    formData.payment_status = 1;
    const token = this.props.auth.user.accessToken;
    this.props.edit_order_vendor_side_payment(
      token,
      formData,
      orderId,
      this.onSuccessPayment
    );
  };

  onSuccessCoupon = () => {
    Alert.success(`<h4>Offer applied sucessfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  onFailureCoupon = (err) => {
    Alert.error(`<h4>${err?.response?.data?.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  checkAndApplyOffer = (code, price) => {
    const token = this.props.auth.user.accessToken;
    const vendorId = this.props.auth.user.VendorUser._id;
    let queryData = {
      vendor_id: vendorId,
      coupon_code: code,
      user_id: this.props?.user_data?.user_details?.userId,
      order_amount: price,
    };
    if (this.state?.offerCodeData?.isPercentage === false) {
      if (
        parseInt(price) >= this.state?.offerCodeData?.minimum_order_applied &&
        parseInt(price) <= this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCoupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is ${parseInt(price) >= this.state?.offerCodeData?.minimum_order_applied ? "more" : "less"} than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    } else if (this.state?.offerCodeData?.isPercentage === true) {
      if (
        parseInt(price) >= this.state?.offerCodeData?.minimum_order_applied &&
        parseInt(price) <= this.state?.offerCodeData?.maximum_order_applied
      ) {
        this.props.apply_offer_code(
          token,
          queryData,
          this.onSuccessCoupon,
          (err) => this.onFailureCoupon(err)
        );
      } else {
        Alert.error(
          `<h4>Offer code not apply because item price is ${parseInt(price) >= this.state?.offerCodeData?.minimum_order_applied ? "more" : "less"} than offer price</h4>`,
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      }
    }
  };

  incrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    cartData[index][0].quantity = qty + 1;
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength + 1;
          break;
        }
      }
    }

    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  handleCancel = () => {
    this.setState({ ...this.state, minAmountModal: false });
    return this.props?.history.push("/orderdashboard/10");
  };

  handleMenu = () => {
    this.setState({ ...this.state, minAmountModal: false });
    return this.props?.history.push("/orderrequest");
  };

  decrementHandler = (itemId, qty, index) => {
    let cartData = JSON.parse(JSON.stringify(this.props.cart_data));
    if (cartData[index][0].quantity - 1 === 0) {
      cartData.splice(index, 1);
    } else {
      cartData[index][0].quantity = qty - 1;
    }
    store.dispatch({
      type: SET_VENDOR_ORDERING_CART_DATA_QUANTITY,
      payload: cartData,
    });

    let globalQty = 0;
    for (let i = 0; i < this.props.vendor_filtered_menu.length; i++) {
      for (
        let j = 0;
        j < this.props.vendor_filtered_menu[i].items.length;
        j++
      ) {
        if (this.props.vendor_filtered_menu[i].items[j]._id === itemId) {
          globalQty =
            this.props.vendor_filtered_menu[i].items[j].cartLength - 1;
          break;
        }
      }
    }
    const formData = {};
    formData.cartLength = globalQty;
    formData.id = itemId;
    store.dispatch({
      type: UPDATE_CART_FILTERED_MENU_ORDER,
      payload: formData,
    });
  };

  onClickProceed = () => {
    const formData = this.props.user_data;
    // External Wallet Validation
    if (formData.payment_method === 8 && !formData.walletDetails) {
      errorAlert("Please Enter Transaction Details");
      return;
    }

    formData.order_items = [];
    const exisitingCartData = this.props.cart_data;
    const totalBaseAmt = calcTotalOriginal(exisitingCartData);

    formData.base_amount = totalBaseAmt;

    if (formData.order_type === 7) {
      let subscription = this.props.subscription;
      let minAmount = 0;
      if (subscription.casual_dining) {
        minAmount =
          subscription?.casual_dining_status?.ordering?.home_delivery
            ?.minimum_order_value || 0;
      } else if (subscription.fast_food_dining) {
        minAmount =
          subscription?.fast_food_dining?.ordering?.home_delivery
            ?.minimum_order_value || 0;
      } else if (subscription.multi_service_business) {
        minAmount =
          subscription?.multi_service_business?.ordering?.home_delivery
            ?.minimum_order_value || 0;
      }
      if (formData.base_amount < minAmount) {
        this.setState({ ...this.state, minAmountModal: true });
        return;
      }
    }
    //formData.total_amount = parseFloat(totalAmount) + parseFloat(totalCharges);

    formData.gstAmount = this.state.summary?.taxes?.gst;
    formData.surCharges = this.state.summary?.taxes?.surCharges;
    formData.total_amount = Number(this.state.summary?.total);
    formData.payment_status =
      this.props?.user_data?.payment_method === 7 ||
        this.props?.user_data?.payment_method === 8 ||
        this.props?.user_data?.payment_method === 9
        ? 1
        : 0;

    for (let i = 0; i < exisitingCartData.length; i++) {
      formData.order_items.push(exisitingCartData[i][0]);
    }

    formData.tip = {
      value: formData?.tip?.value || 0,
      amount: formData?.tip?.amount,
    };
    formData.notes = formData?.notes || "";
    formData.donation = {
      amount: formData?.donation?.amount || 0,
      value: formData?.donation?.amount || 0,
    };
    formData.discount = { amount: 0, percentage: 0 };
    formData.deliveryCharges = this.props?.user_data?.deliveryCharges;

    if (this.props.user_data.isOfferApplied) {
      formData.discount.amount = calcDiscount(
        this.props.cart_data,
        this.props.user_data,
        this.props.offerData
      );
      if (this.props.user_data.isPercentage) {
        formData.discount.percentage = this.props.user_data.discountAmount;
      }
    }

    formData.deliveryDiscount = calcDeliveryDiscount(this.props.user_data);
    if (
      formData.payment_pending === false ||
      (formData.payment_method === 7 &&
        formData.payment_method === 8 &&
        formData.payment_method === 9 &&
        formData.payment_method === 6 &&
        formData.payment_method === 0)
    ) {
      const token = this.props.auth.user.accessToken;
      delete formData._id;
      this.props.create_order_vedor_side(
        token,
        formData,
        (data, orderId) => this.orderSuccess(data, orderId),
        this.onError
      );
    } else {
      this.displayRazorpay(
        formData.total_amount,
        formData.user_details.userId,
        formData.user_details.first_name,
        formData.user_details.mobile_number,
        formData.user_details.email,
        this.props.order_id
      );
    }
  };

  onClickAvailableOffer = () => {
    this.setState({
      displayAvailableOffers: !this.state.displayAvailableOffers,
    });
  };

  copyFunction = (data) => (e) => {
    let offerData = {
      isPercentage: data?.isPercentage,
      coupon_code: data?.coupon_code,
      discount: data?.discount,
      maximum_discount_applied: data?.maximum_discount_applied,
      maximum_order_applied: data?.maximum_order_applied,
      maximum_usage_limit: data?.maximum_usage_limit,
      minimum_order_applied: data?.minimum_order_applied,
      type: data?.type,
      deliveryMinOrder: data?.deliveryMinOrder,
      deliveryMaxDiscount: data?.deliveryMaxDiscount,
    };
    this.setState({
      offerCodeData: offerData,
    });
    navigator.clipboard.writeText(data?.coupon_code);
    Alert.success(`<h4>Coupon code copied</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  addressType = (type) => {
    if (type) {
      let addressType = DELIVERY_TYPES.find((ele) => ele.id === type);
      return addressType?.icon || DELIVERY_TYPES[0].icon;
    } else {
      return DELIVERY_TYPES[0].icon;
    }
  };

  onOpenClosedInCaseUnAvailability = (e, type, index) => {
    e.preventDefault();
    if (type === "Open") {
      this.setState({
        inCaseUnAvailabilityIndexValue: index,
        inCaseUnAvailability: true,
        inCaseDropDownValue: "",
        inCaseNotes: "",
      });
    } else {
      this.setState({
        inCaseUnAvailabilityIndexValue: "",
        inCaseUnAvailability: false,
        inCaseDropDownValue: "",
        inCaseNotes: "",
      });
    }
  };

  onChangeAvailability = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmitInCaseUnAvailability = (e) => {
    e.preventDefault();
    let actualData = this.props.cart_data;
    let formData = {
      inCaseDropDownValue: this.state.inCaseDropDownValue,
      inCaseNotes: this.state.inCaseNotes,
    };
    if (formData.inCaseDropDownValue !== "" || formData.inCaseNotes !== "") {
      for (let i = 0; i < actualData.length; i++) {
        if (actualData[this.state?.inCaseUnAvailabilityIndexValue][0]) {
          actualData[
            this.state?.inCaseUnAvailabilityIndexValue
          ][0].incase_of_unavailable = this.state.inCaseDropDownValue;
          actualData[this.state?.inCaseUnAvailabilityIndexValue][0].notes =
            this.state.inCaseNotes;
          break;
        }
      }
    } else {
      Alert.error(`<h4>Please fill all the fields</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
    this.setState({
      inCaseUnAvailability: false,
    });
  };

  onClickAddMoreItem = () => {
    let cartData = this.props.cart_data;
    let userData = this.props.user_data;
    this.props.history.push({
      pathname: "/orderrequest",
      state: { cartData: cartData, userData: userData },
    });
    // this.props.history.push("/orderrequest")
  };

  render() {
    try {
      const { cart, payment, cart_data, onboarding, cart_data_two } =
        this?.props;
      const {
        tip,
        open,
        openTract,
        donationId,
        inCaseUnAvailability,
        summary,
      } = this.state;
      return (
        <React.Fragment>
          <Container fluid>
            {!this.props.onlyPayment && (
              <>
                <CustomerEditModel
                  cart={cart}
                  payment={payment}
                  cart_data={cart_data}
                  orderBufferTime={onboarding.orderBufferTime}
                />
                {this.props?.user_data?.order_type === 7 ? (
                  <React.Fragment>
                    <div className="row mb-3">
                      <div className="col-2">
                        <div
                          className="border"
                          style={{
                            borderRadius: "50px",
                            width: "30px",
                            height: "30px",
                            textAlign: "center",
                          }}
                        >
                          <img
                            src={this.addressType(
                              this.props?.user_data?.address?.type
                            )}
                            className="img-fluid"
                            style={{ width: "50%" }}
                            alt="Address Type"
                            title="Address Type"
                          />
                        </div>
                      </div>
                      <div className="col-7">
                        <div className="f12-500">
                          {this.props?.user_data?.address?.address1}
                        </div>
                        {this.props?.user_data?.address?.area || ""}{" "}
                        {this.props?.user_data?.address?.city || ""}
                      </div>
                    </div>
                    <hr />
                  </React.Fragment>
                ) : null}
                {/* {cart !== 0 && ( */}
                {cart_data_two.length > 0 ? (
                  <div>
                    <h6 className="mb-2" style={{ fontSize: "18px" }}>
                      {" "}
                      {!this.props.payment && !this.props.cart
                        ? "Old Item Details"
                        : "Items Added to Cart"}
                    </h6>
                    {payment ? (
                      <div
                        className="f14-500"
                        style={{ color: "#2196F3", cursor: "pointer" }}
                        onClick={() => this.onClickAddMoreItem()}
                      >
                        Add More Items to Cart
                      </div>
                    ) : (
                      <>
                        <Media query="(max-width: 991px)">
                          <div
                            className="f14-500"
                            style={{ color: "#2196F3", cursor: "pointer" }}
                            onClick={() => this.props.setDefault(false)}
                          >
                            Add More Items to Cart
                          </div>
                        </Media>
                      </>
                    )}

                    {this.props.cart_data.map((item, index) => (
                      <Fragment key={index}>
                        <div
                          className="row f10-400"
                          style={{ marginTop: "30px" }}
                        >
                          <Col md={3} xs={3}>
                            <img
                              src={
                                (item[0] &&
                                  item[0].item &&
                                  item[0].item.images[0]) ||
                                NOTAVAILABLEIMAGE
                              }
                              width="60px"
                            // width="100%"
                            />
                          </Col>
                          <Col md={6} xs={6}>
                            <h3 className="f12-500">
                              {ITEMTYPEVEG.map((type, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    {item &&
                                      item[0]?.itemType === type?.value ? (
                                      <Image
                                        width="15px"
                                        height="15px"
                                        src={type.url}
                                        alt={type.title}
                                        title={type.title}
                                        fluid
                                      />
                                    ) : null}
                                  </React.Fragment>
                                );
                              })}{" "}
                              {/* {item.item.name} */}
                              {item[0].item.name}
                              {/* {item[0].quantity} */}
                            </h3>
                            <h3 className="f10-400 my-1">
                              {item[0].size.description}
                            </h3>

                            {/* {console.log(
                              "Customized =====>>>>>",
                              item && item[0]
                            )} */}
                            {item && item[0]?.customised ? (
                              <p
                                className="f10-500"
                                style={{ color: "#EE3A23" }}
                              >
                                Customized
                              </p>
                            ) : null}
                            {/* {item[0] &&
                              item[0].addOns &&
                              item[0].addOns.length > 0 ? (
                              <p>AddOn : {this.prepareAddOn(item[0].addOns)}</p>
                            ) : (
                              <></>
                            )} */}
                          </Col>
                          <Col md={3} xs={3}>
                            <div className="f12-700">
                              {" "}
                              ₹ {item[0].finalPrice * item[0].quantity}
                            </div>
                          </Col>
                        </div>
                        <div className="row">
                          <div className="col-3"></div>
                          <div className="col-9">
                            {item[0] &&
                              item[0].addOns &&
                              item[0].addOns.length > 0 ? (
                              <div className="row f10-400">
                                <div className="col-3 pr-1">AddOn : </div>
                                <div className="col-9">
                                  {this.prepareAddOn(item[0].addOns).map(
                                    (data, index) => {
                                      return (
                                        <div className="f10-400" key={index}>
                                          {data.name.toString()},{" "}
                                          {!isEmpty(data?.multipleSize) &&
                                            data?.multipleSize.map(
                                              (data, index) => {
                                                return data?.checked ===
                                                  true ? (
                                                  <React.Fragment key={index}>
                                                    {data?.sizeDescription.toString()}
                                                    ,{" "}
                                                  </React.Fragment>
                                                ) : null;
                                              }
                                            )}
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                        <div className="col-9 mt-2 offset-3 p-0 d-flex align-items-center">
                          {item &&
                            item[0] &&
                            item[0].incase_of_unavailable === "" ? (
                            <>
                              <button
                                title="Add Incase of Unavailability"
                                type="button"
                                className="btn p-0 f12-500"
                                style={{ color: "rgb(33, 150, 243)" }}
                                onClick={(e) =>
                                  this.onOpenClosedInCaseUnAvailability(
                                    e,
                                    "Open",
                                    index
                                  )
                                }
                              >
                                Add Incase of Unavailability
                              </button>
                            </>
                          ) : (
                            <>
                              <span className="f9-500 opacity5">
                                Incase of Unavailability :&nbsp;
                              </span>
                              <button
                                type="button"
                                className="btn p-0 f12-500"
                                style={{ color: "rgb(33, 150, 243)" }}
                                onClick={(e) =>
                                  this.onOpenClosedInCaseUnAvailability(
                                    e,
                                    "Open",
                                    index
                                  )
                                }
                              >
                                {
                                  INCASEOFUNAVAILABILITY[
                                  item[0] && item[0]?.incase_of_unavailable
                                  ]
                                }
                              </button>
                            </>
                          )}
                        </div>
                        {item[0] && item[0].notes ? (
                          <div className="col-9 offset-3 p-0 mb-2 d-flex align-items-center">
                            <span className="f9-500 opacity5">Notes : </span>
                            <span className="f10-500">{item[0].notes}</span>
                          </div>
                        ) : (
                          <> </>
                        )}
                        {!payment && (
                          <div class="" align="center">
                            <div class="row" style={{ paddingLeft: "5rem" }}>
                              <div className="col-1 p-0 ml-4">
                                <button
                                  type="button"
                                  class="p-0 btn btn-link"
                                  // onClick={decrementHandler}
                                  onClick={() =>
                                    this.decrementHandler(
                                      item[0].itemId,
                                      item[0].quantity,
                                      index
                                    )
                                  }
                                >
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                                    alt="Minus"
                                    title="Minus"
                                    class="img-fluid"
                                    width="60px"
                                  />
                                </button>
                              </div>
                              <div className="col-1 p-0 mr-3">
                                <input
                                  //placeholder={item[0].quantity}
                                  value={item[0].quantity}
                                  class="enInputValueOnly f12-700"
                                  width="30px"
                                  onChange={() => { }}
                                />
                              </div>
                              <div className="col-1 p-0">
                                <button
                                  type="button"
                                  class="p-0 btn btn-link"
                                  onClick={() =>
                                    this.incrementHandler(
                                      item[0].itemId,
                                      item[0].quantity,
                                      index
                                    )
                                  }
                                //onClick={incrementHandler}
                                // onClick={() => setShowRepeatSize(true)}
                                >
                                  <img
                                    src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                                    alt="add "
                                    title="add"
                                    class="img-fluid"
                                    width="60px"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        )}

                        <hr />
                      </Fragment>
                    ))}

                    {/* <div
              style={{
                paddingTop: !this.props.payment && !this.props.cart && "10%",
              }}
            >
              <h6>
                {!this.props.payment &&
                  !this.props.cart &&
                  "Substituted Item Selected"}
              </h6>
              <div className="row  f10-400" style={{ marginTop: "30px" }}>
                <Col md={3}>
                  <img
                    src={require("../../../../assets/images/Orders/Mask Group 113.png")}
                    // width="100%"
                  />
                </Col>
                <Col md={9}>
                  <h6>
                    <img
                      src={require("../../../../assets/images/superadmin/ordericon/veg.svg")}
                      width="15px"
                      heigth="15px"
                    />{" "}
                    Mexican Wave Pizza
                  </h6>
                  Small
                  <p style={{ color: "#EE3A23  " }}>Customized</p>
                  <p>
                    Crust: New Hand Tossed Add On: Onion, Capsicum, Mushroom
                  </p>
                </Col>
              </div>
            </div> */}
                    {/* Increments & decrements */}
                    <br />
                    {!payment && (
                      <div>
                        {/* <div class="pl-md-2 enPartyPersonEdit" align="center">
                  <div class=" align-items-center">
                    <button
                      type="button"
                      class="p-0 btn btn-link"
                      onClick={this.decrementHandler}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/less.svg")}
                        alt="Minus"
                        title="Minus"
                        class="img-fluid"
                        width="30px"
                      />
                    </button>
                    <input
                      placeholder="00"
                      value={cart}
                      class="enInputValueOnly f12-700"
                      width="30px"
                      onChange={() => {}}
                    />
                    <button
                      type="button"
                      class="p-0 btn btn-link"
                      onClick={this.incrementHandler}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/add.svg")}
                        alt="Minus"
                        title="Minus"
                        class="img-fluid"
                        width="30px"
                      />
                    </button>
                  </div>
                </div> */}
                        <hr />
                        <h3 className="f18-700">Suggested item</h3>
                        <br />
                        <div>
                          <CarouselMain />
                          {/* <div
                    id="carouselExampleControls"
                    class="carousel slide"
                    data-ride="carousel"
                  >
                    <ol class="carousel-indicators">
                      {suggestions.map((data, index) => {
                        return (
                          <li
                            data-target="#carouselExampleControls"
                            data-slide-to={`${index}`}
                            class={`${index === 0 && `active`}`}
                            key={index}
                          ></li>
                        );
                      })}
                    </ol>
                    <div class="carousel-inner f12-400">
                      {suggestions.map((data) => {
                        return (
                          <div
                            class={`carousel-item ${data.id === 0 && `active`}`}
                          >
                            <div class="card" style={{ width: "100%" }}>
                              <img
                                class="card-img-top"
                                src={require("../../../../assets/images/Orders/Mask Group 113.png")}
                                alt="Card image"
                                style={{ width: "100%", maxHeight: "150px" }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  top: "40%",
                                  left: "5%",
                                }}
                                class="bottom-left"
                                className="badge badge-warning"
                              >
                                Best Selling
                              </div>
                              <div class="card-body">
                                <table style={{ width: "100%" }}>
                                  <tbody>
                                    <tr>
                                      <td>
                                        <img
                                          src={require("../../../../assets/images/superadmin/ordericon/veg.svg")}
                                          width="15px"
                                          heigth="15px"
                                        />
                                      </td>
                                      <td>
                                        <span className="f12-700">
                                          {data.title}
                                        </span>
                                        <br />
                                        <img
                                          src={require("../../../../assets/images/superadmin/ordericon/star.svg")}
                                          width="10px"
                                          heigth="10px"
                                        />
                                        4.2 (550 reviews)
                                      </td>
                                    </tr>
                                    <tr>
                                      <td>
                                        <img
                                          src={require("../../../../assets/images/superadmin/ordericon/rupees.svg")}
                                          width="30px"
                                        />
                                      </td>
                                      <td>
                                        <span className="f12-700">
                                          {data.price}
                                        </span>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <button
                                  type="button"
                                  class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                                  title="Save Button"
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    {/* <a
                      class="carousel-control-prev"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="prev"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-prev-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Previous</span>
                    </a>
                    <a
                      class="carousel-control-next"
                      href="#carouselExampleControls"
                      role="button"
                      data-slide="next"
                      style={{ bottom: 0 }}
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span class="sr-only">Next</span>
                    </a> 
                  </div> */}

                          {/*  */}
                        </div>
                        <br />

                        {/* <h6>Add Notes For Kitchen</h6> */}
                        <hr />
                        <Fragment>
                          <div style={{ backgroundColor: "#F8F8F8" }}>
                            <div
                              // style={{
                              //   paddingTop: "10px",
                              //   paddingLeft: "10px",
                              // }}
                              className="d-flex justify-content-between pt-2 px-3 align-items-center"
                            >
                              <h6>Add Tip</h6>{" "}
                              <VendorLearnMore
                                heading="Add Tip"
                                paragraphText={
                                  <>
                                    Tips: Terms and Conditions <br /> <br />{" "}
                                    A Customer may at its sole discretion add a
                                    certain amount as “Tip” for the services
                                    provided through the Amealio Platform.{" "}
                                    <br /> <br /> Any amount received towards
                                    Tips shall be non-refundable except in the
                                    following circumstances:
                                    <br /> <br /> a) Order is auto-cancelled
                                    before the acceptance of the order by the
                                    Merchant. <br /> <br /> b) If the Order is
                                    cancelled by the Merchant due to reasons
                                    such as non-availability of food items
                                    ordered by the Customer, non – availability
                                    of the service, or any other reasons
                                    attributable to the Merchant. However, in
                                    case of partial cancellation or
                                    modifications in the Order/Booking, the
                                    amount contributed towards Tips shall be
                                    non-refundable.
                                    <br /> <br /> Amealio reserves the right, at
                                    its sole discretion, to refuse the refund of
                                    amount paid towards Tips for any reason
                                    whatsoever, without assigning any reason to
                                    the Customer and the Customer accepts and
                                    undertakes to not raise any dispute on the
                                    same. <br /> <br />
                                  </>
                                }
                              />
                            </div>
                            <br />
                            <Row
                              // style={{ marginLeft: "3%" }}
                              className="superadmin-orderscomponent-main f12-400 px-3"
                            >
                              {tips.map((data, index) => {
                                return (
                                  <React.Fragment key={index}>
                                    <Col
                                      xs={4}
                                      sm={4}
                                      md={4}
                                      align="center"
                                      onClick={() =>
                                        this.setTips(data.id, data.amount)
                                      }
                                      key={data.id}
                                    >
                                      <div
                                        className={`take-away-order-select d-flex f12-500 justify-content-center
                                  ${tip === data.id &&
                                          `take-away-order-select-selected`
                                          }`}
                                        style={{
                                          padding: "10px",
                                          // marginRight: "12%",
                                          marginBottom: "8%",
                                        }}
                                      >
                                        {data.title === "None" ? (
                                          ""
                                        ) : (
                                          <p style={{ color: "#ee3a23" }}>₹</p>
                                        )}
                                        &nbsp;
                                        {data.title}
                                      </div>
                                    </Col>
                                  </React.Fragment>
                                );
                              })}
                              {this.state.customButtonTip ? (
                                ""
                              ) : (
                                <div
                                  className="take-away-order-select ml-3 f12-500"
                                  style={{
                                    padding: "10px",
                                    marginBottom: "8%",
                                  }}
                                  onClick={this.onCustomTipAccount}
                                >
                                  Custom
                                </div>
                              )}
                              {this.state.customButtonTip ? (
                                <div className="col-12 mt-4">
                                  <div className="row">
                                    <div className="col-8">
                                      <NewInputText
                                        controlClass={"customButtonTipText"}
                                        placeHolder="Enter Amount"
                                        type="number"
                                        labelText="Enter Amount"
                                        variant="outlined"
                                        onInput={() => this.maxLengthCheck}
                                        maxLength={3}
                                        name="customButtonTipText"
                                        onChange={this.onHandleChange}
                                        value={this.state.customButtonTipText}
                                      />
                                    </div>
                                    <div className="col-4">
                                      <button
                                        className="btn btn-primary"
                                        onClick={
                                          this.onClickSaveCustomButtonTips
                                        }
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </Row>
                          </div>
                        </Fragment>
                        <Fragment>
                          <hr />
                          <div style={{ backgroundColor: "#FFFBEE" }}>
                            <div
                              // style={{
                              //   paddingTop: "10px",
                              //   paddingLeft: "10px",
                              // }}
                              className="d-flex justify-content-between pt-2 px-3 align-items-center"
                            >
                              <h6>Want to Donate to Smiles?</h6>
                              <VendorLearnMore
                                modalimage={
                                  require("../../../../assets/images/udbhav.png")
                                    .default
                                }
                                heading="Donate to Udbhav"
                                paragraphText="Udbhav is our projection of help towards the society. Any sizable donation matters. Please donate to help the needy and feed the hunger. Donations will be given to a social cause. We ensure transparency in showing you the records of our donations. Your every penny counts and will be used to save a life!"
                              />
                            </div>
                            <br />
                            <Row
                              // style={{ marginLeft: "3%" }}
                              className="superadmin-orderscomponent-main px-3"
                            >
                              {donates.map((data) => {
                                return (
                                  <Col
                                    xs={4}
                                    sm={4}
                                    md={4}
                                    // className="p-0"
                                    align="center"
                                    onClick={() =>
                                      this.setDonation(data.id, data.amount)
                                    }
                                    key={data.id}
                                  >
                                    <div
                                      className={`take-away-order-select d-flex f12-500 justify-content-center
                                  ${donationId === data.id &&
                                        `take-away-order-select-selected`
                                        }`}
                                      style={{
                                        padding: "10px",
                                        marginBottom: "8%",
                                      }}
                                    >
                                      {data.title === "None" ? (
                                        ""
                                      ) : (
                                        <p style={{ color: "#ee3a23" }}>₹</p>
                                      )}
                                      &nbsp;
                                      {data.title}
                                    </div>
                                  </Col>
                                );
                              })}
                              {this.state.customButtonDonate ? (
                                ""
                              ) : (
                                <div
                                  className="take-away-order-select ml-3 f12-500"
                                  style={{
                                    padding: "10px",
                                    marginBottom: "8%",
                                  }}
                                  onClick={this.onCustomTipDiscountAccount}
                                >
                                  Custom
                                </div>
                              )}
                              {this.state.customButtonDonate ? (
                                <div className="col-12 mt-4">
                                  <div className="row">
                                    <div className="col-8">
                                      <NewInputText
                                        controlClass={"customButtonDonateText"}
                                        placeHolder="Enter Amount"
                                        type="number"
                                        labelText="Enter Amount"
                                        variant="outlined"
                                        onInput={() => this.maxLengthCheck}
                                        maxLength={3}
                                        onKeyPress={(event) => {
                                          if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                        name="customButtonDonateText"
                                        onChange={this.onHandleChange}
                                        value={
                                          this.state.customButtonDonateText
                                        }
                                      />
                                    </div>
                                    <div className="col-4">
                                      <button
                                        className="btn btn-primary"
                                        onClick={
                                          this.onClickSaveCustomButtonDonate
                                        }
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </Row>
                          </div>
                        </Fragment>

                        {this.props.cart_data.length > 0 ? (
                          <div style={{ paddingTop: "5%" }}>
                            <h6>Apply Promotions</h6>
                            <br />
                            <InputPromotion
                              offer_code={this.props.user_data}
                              apply_offer={(code) =>
                                this.checkAndApplyOffer(
                                  code,
                                  calcTotalOriginal(this.props.cart_data)
                                )
                              }
                            />
                            <div className="row">
                              <div className="col-12 pt-3 pb-3 d-flex justify-content-end">
                                <button
                                  onClick={this.onClickAvailableOffer}
                                  className="btn p-0 w-50 f10-500"
                                  style={{ color: "#EE3A23" }}
                                  type="button"
                                >
                                  {this.state.displayAvailableOffers
                                    ? "Hide Available Offers"
                                    : "Show Available Offers"}
                                  <i
                                    className={
                                      this.state.displayAvailableOffers
                                        ? "fa fa-chevron-up ml-2"
                                        : "fa fa-chevron-down ml-2"
                                    }
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                              <div className="col-12">
                                {this.state.displayAvailableOffers ? (
                                  <div className="col-12">
                                    {this.state &&
                                      this.state.availableOffers.map(
                                        (offer, index) => {
                                          return (
                                            <React.Fragment key={index}>
                                              <div className="row align-items-center">
                                                <div className="col-8 d-flex align-items-center">
                                                  <div
                                                    className="mr-2"
                                                    style={{
                                                      width: "35px",
                                                      height: "35px",
                                                      borderRadius: "50%",
                                                    }}
                                                  >
                                                    <SimpleReactLightbox>
                                                      <SRLWrapper
                                                        options={optionsImage}
                                                      >
                                                        <img
                                                          alt={offer?.name}
                                                          title={offer?.name}
                                                          src={
                                                            offer?.photo_thumbnails &&
                                                            offer
                                                              ?.photo_thumbnails[0]
                                                          }
                                                          style={{
                                                            width: "100%",
                                                            height: "35px",
                                                            borderRadius: "50%",
                                                          }}
                                                        />
                                                      </SRLWrapper>
                                                    </SimpleReactLightbox>
                                                  </div>
                                                  <p className="f14-500">
                                                    {offer?.coupon_code}
                                                  </p>
                                                </div>
                                                <div className="col-4">
                                                  <i
                                                    className="fa fa-clone ml-2"
                                                    aria-hidden="true"
                                                    onClick={this.copyFunction(
                                                      offer
                                                    )}
                                                  ></i>
                                                  <p
                                                    className="f9-400 opacity5"
                                                    onClick={this.copyFunction(
                                                      offer
                                                    )}
                                                  >
                                                    Copy Code
                                                  </p>
                                                </div>
                                              </div>
                                              <hr />
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                  </div>
                                ) : (
                                  <div></div>
                                )}
                              </div>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    )}

                    <Fragment>
                      {this.props.cart_data.length > 0 ? (
                        <Fragment>
                          <hr />
                          <div style={{ paddingTop: "5%" }}>
                            <h6>Order Summary</h6>
                            <br />
                            <table style={{ width: "100%" }}>
                              <tbody>
                                <tr>
                                  <td>Original Item Value</td>
                                  {this.props.cart_data.length > 0 ? (
                                    <td
                                      style={{
                                        textAlign: "end",
                                      }}
                                    >
                                      ₹{calcTotalOriginal(this.props.cart_data)}
                                    </td>
                                  ) : (
                                    <> </>
                                  )}
                                </tr>
                                <tr>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <p className="mr-1">Taxes</p>
                                      {summary?.taxes?.gstTotal && (
                                        <InfoToolTip
                                          title={"Taxes"}
                                          hover={true}
                                          data={summary?.taxes?.gst || {}}
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "end" }}>
                                    {summary?.taxes?.gstTotal > 0 ? (
                                      <>
                                        ₹{parseFloat(summary?.taxes?.gstTotal).toFixed(2)}
                                      </>
                                    ) : (
                                      <> ₹0</>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <p className="mr-1">Surcharges</p>

                                      {summary?.taxes?.surTotal ? (
                                        <InfoToolTip
                                          title={"Surcharges"}
                                          hover={true}
                                          data={
                                            summary?.taxes?.surCharges || {}
                                          }
                                        />
                                      ) : <></>}
                                    </div>
                                  </td>
                                  <td style={{ textAlign: "end" }}>
                                    {summary?.taxes?.surTotal ? (
                                      <>
                                        ₹{parseFloat(summary?.taxes?.surTotal).toFixed(2)}
                                      </>
                                    ) : (
                                      <> ₹0.00</>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Tips</td>
                                  <td style={{ textAlign: "end" }}>
                                    {this.props.cart_data.length > 0 ? (
                                      <>
                                        ₹
                                        {this.props.user_data?.tip?.amount?.toFixed(
                                          2
                                        ) || 0.0}
                                      </>
                                    ) : (
                                      <> ₹0</>
                                    )}
                                  </td>
                                </tr>

                                <tr>
                                  <td>Donation</td>
                                  <td style={{ textAlign: "end" }}>
                                    ₹
                                    {this.props.user_data?.donation?.amount?.toFixed(
                                      2
                                    )}
                                    {/* {this.props.user_data &&
                                  this.props.user_data.donation &&
                                  this.props.user_data.donation.amount ? (
                                    <>
                                      {" "}
                                      ₹{this.props.user_data.donation.amount}
                                    </>
                                  ) : (
                                    <>₹2.00</>
                                  )} */}
                                  </td>
                                </tr>

                                <tr>
                                  <td>Discount</td>
                                  <td style={{ textAlign: "end" }}>
                                    {this.props.user_data.isOfferApplied ? (
                                      <>
                                        ₹
                                        {calcDiscount(
                                          this.props.cart_data,
                                          this.props.user_data,
                                          this.props.offerData
                                        )}
                                      </>
                                    ) : (
                                      <> ₹0.00</>
                                    )}
                                  </td>
                                </tr>
                                {(this.props.user_data?.delivery_partner == 2 && this.props.user_data?.order_type === 7) ? (
                                  <>
                                    <tr>
                                      <td>Delivery</td>
                                      <td style={{ textAlign: "end" }}>
                                        ₹
                                        {parseFloat(
                                          this.props.user_data?.deliveryCharges
                                            ?.user
                                        ).toFixed(2) || "0.00"}
                                      </td>
                                    </tr>
                                    {this.props.user_data?.isDelivery &&
                                      <>
                                        <tr>
                                          <td>Delivery Discount</td>
                                          <td style={{ textAlign: "end", marginLeft: '4px' }}>
                                            ₹
                                            {parseFloat(
                                              calcDeliveryDiscount(this.props.user_data)
                                            ).toFixed(2) || "0.00"}
                                          </td>
                                        </tr>
                                      </>
                                    }
                                  </>
                                ) : null}
                                <tr>
                                  <td colSpan={2}>
                                    <hr />
                                  </td>
                                </tr>
                                <tr
                                  style={{
                                    backgroundColor: "#F8F8F8",
                                  }}
                                >
                                  <td className="f14-700">To be Paid</td>
                                  <td
                                    className="f14-700"
                                    style={{ textAlign: "end" }}
                                  >
                                    {summary?.total > 0 ? (
                                      <>₹ {summary?.total}</>
                                    ) : (
                                      <> ₹0.00</>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <hr />
                          <div class="mt-3 d-flex mobile-mb-7">
                            <button
                              type="button"
                              class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                              title="Cancel Button"
                              onClick={() =>
                                this.props.size < 991 && this.props.showdefault
                                  ? this.props.setDefault(false)
                                  : this.props.history.push("/orderdashboard")
                              }
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                              title="Save Button"
                              onClick={() => {
                                if (!payment) this.checkAvailability();
                                if (payment) {
                                  this.onClickProceed();
                                }
                              }}
                            >
                              Proceed
                            </button>
                          </div>
                        </Fragment>
                      ) : (
                        <> </>
                      )}
                    </Fragment>
                    <hr />
                  </div>
                ) : (
                  <div
                    className="px-5 w-100 text-center d-flex align-items-center justify-content-between"
                    style={{ height: "275px" }}
                  >
                    <div
                      className="f20-700"
                      style={{
                        opacity: 0.3,
                      }}
                    >
                      Your cart is empty. Add an item to begin
                    </div>
                  </div>
                )}
                {this.state.minAmountModal && (
                  <MinAmountModal
                    subscription={this.props.subscription}
                    handleCancel={this.handleCancel}
                    handleMenu={this.handleMenu}
                  />
                )}
                {payment && (
                  <PaymentSuccessModel
                    open={open}
                    props={this.props}
                    setOpenTract={this.setOpenTract}
                  />
                )}
                {payment && (
                  <OrderTrackEntry open={openTract} props={this.props} />
                )}
              </>
            )}
            <>
              <div
                className={`${this.props.cart_data.length === 0 && "mt-3"
                  } d-flex`}
              >
                {this.props.cart_data.length === 0 &&
                  (this.props.size < 991 ? (
                    <React.Fragment>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                        title="Cancel Button"
                        onClick={() =>
                          this.props.size < 991 && this.props.showdefault
                            ? this.props.setDefault(false)
                            : this.props.history.push("/orderdashboard")
                        }
                      >
                        Back to menu item
                      </button>
                      <button
                        type="button"
                        className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                        title="Cancel Button"
                        onClick={() =>
                          this.props.size < 991 && this.props.showdefault
                            ? this.props.history.push("/orderdashboard")
                            : this.props.history.push("/orderdashboard")
                        }
                      >
                        Cancel Order
                      </button>
                    </React.Fragment>
                  ) : (
                    ""
                  ))}
                {this.props.cart_data.length > 0 && this.props.onlyPayment && (
                  <React.Fragment>
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                      title="Cancel Button"
                      onClick={() =>
                        this.props.size < 991 && this.props.showdefault
                          ? this.props.setDefault(false)
                          : this.props.history.push("/orderdashboard")
                      }
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                      title="Proceed Button"
                      onClick={() => {
                        if (!payment) this.props.history.push("/orderpayment");

                        if (payment) {
                          this.onClickProceed();
                        }
                      }}
                    >
                      Proceed
                    </button>
                  </React.Fragment>
                )}
              </div>
            </>
          </Container>
          <Modal show={inCaseUnAvailability} size="md" centered>
            <Modal.Header className="border-0">
              <Modal.Title className="f24_700_HelveticaNeue">
                Incase of Unavailability
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <FormControl fullWidth variant="outlined">
                  <InputLabel id="demo-simple-select-label">
                    Select In Case Of Unavailability
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="inCaseDropDownValue"
                    value={this.state.inCaseDropDownValue}
                    onChange={(e) => this.onChangeAvailability(e)}
                    label="Select In Case Of Unavailability"
                  >
                    <MenuItem value="" disabled selected>
                      Select In Case Of Unavailability
                    </MenuItem>
                    {INCASEOFUNAVAILABILITY?.map((data, index) => {
                      return (
                        <MenuItem
                          label="Select In Case Of Unavailability"
                          key={index}
                          value={index}
                          style={{ fontWeight: 500 }}
                        >
                          {data}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <hr />
              <h5>
                <b>Add Note</b>
              </h5>
              <br />
              <textarea
                className="form-control"
                placeholder="Any special instructions"
                name="inCaseNotes"
                value={this.state.inCaseNotes}
                onChange={(e) => this.onChangeAvailability(e)}
              // onChange={(e) => onChangeAddNote(e)}
              ></textarea>
              <hr />
              <div class="mt-3 d-flex align-items-center">
                <button
                  type="button"
                  className="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-4"
                  style={{ paddingTop: "15px", paddingBottom: "15px" }}
                  title="Track Button"
                  onClick={(e) =>
                    this.onOpenClosedInCaseUnAvailability(e, "Closed")
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                  style={{ paddingTop: "15px", paddingBottom: "15px" }}
                  title="Submit"
                  onClick={(e) => this.onSubmitInCaseUnAvailability(e)}
                >
                  Save
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </React.Fragment>
      );
    } catch (e) {
      console.log(e);
    }
  }
}

const OrderTrackEntry = (props) => {
  try {
    return (
      <React.Fragment>
        <Modal show={props.open} size="md" centered>
          {/* <Modal.Header className="border-0" closeButton> */}
          {/* <Modal.Title className="f24_700_HelveticaNeue">
        Edit Customer Details
      </Modal.Title> */}
          {/* </Modal.Header> */}
          <Modal.Body>
            <h3>Order Success</h3>
            <br />
            <img
              src={require("../../../../assets/images/superadmin/ordericon/success.svg")}
              width="65px"
            />{" "}
            <br />
            <br />
            <b>Your Order has been placed successfully</b>
            <br />
            <div class="mt-3 d-flex">
              <button
                type="button"
                class="onboarding_button_link_reusable onboarding_button_link_reusable_red"
                title="Track Button"
                onClick={() => {
                  props.props.history.push("/ordertrack");
                }}
              >
                Track Order
              </button>
              <button
                type="button"
                class="onboarding_button_link_reusable onboarding_button_link_reusable_white mr-3"
                title="Okay"
                onClick={() => {
                  // props.props.history.push("/ordertrack");
                }}
              >
                Okay
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    console.log(e);
  }
};

export const PaymentSuccessModel = (props) => {
  const [success, setSuccess] = React.useState(false);
  let history = useHistory();
  const [orderData, setOrderData] = useState({});
  const clearAndRedirect = () => {
    store.dispatch({
      type: CLEAR_CART_DATA,
      //payload: formData,
    });
    store.dispatch({
      type: CLEAR_CART_DATA_USER_DATA,
      //payload: formData,
    });
    history.push("/orderdashboard");
  };
  useEffect(() => {
    setOrderData(props.data);
  }, [props.data]);

  const calcTaxes = (data) => {
    let tax = Object.values(data).reduce(
      (a, b) => parseFloat(a || 0) + parseFloat(b || 0),
      0
    );
    return tax.toFixed(2);
  };

  try {
    return (
      <React.Fragment>
        <Modal show={props.open} size="md" centered>
          <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
          <Modal.Body className="p-0">
            <div
              className="px-4 py-3 mt-2"
              style={{ backgroundColor: "#FFFBEE" }}
            >
              <div className="row">
                <div className="col-6 f11-400">
                  Order ID:{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData.order_id}
                  </span>
                </div>
                <div className="col-6" align="right">
                  <span
                    className="badge badge-warning f9-700 px-2 py-1"
                    style={{ borderRadius: "50px" }}
                  >
                    {" "}
                    {/* {orderData.order_type === 0
                      ? "Take Away"
                      : orderData.order_type === 1
                      ? "Curb Side"
                      : orderData.order_type === 2
                      ? "Skip the line"
                      : orderData.order_type === 3
                      ? "Dine In"
                      : null} */}
                    {ORDER_TYPE_NAME[orderData.order_type]}
                  </span>
                </div>
              </div>
              <h1
                className="pt-1 pb-3"
                style={{
                  fontSize: "30px",
                  lineHeight: "35px",
                  fontFamily: "Roboto-Bold",
                  letterSpacing: "1px",
                  color: "#212121",
                }}
              >
                Payment{" "}
                {`${orderData.payment_status === 1
                  ? "Success"
                  : orderData.payment_method === 6 &&
                    orderData?.payment_status === 0
                    ? "Unsettled"
                    : orderData?.payment_status === 0
                      ? "Failed"
                      : "Failed"
                  }`}
              </h1>
              <Row className="align-items-center">
                <Col xs={2}>
                  <img
                    src={require(`../../../../assets/images/superadmin/ordericon/${orderData.payment_method === 0 ||
                      orderData.payment_status === 1
                      ? `success`
                      : orderData.payment_method === 6 &&
                        orderData?.payment_status === 0
                        ? `alert`
                        : orderData?.payment_status === 0
                          ? `error`
                          : `error`
                      }.svg`)}
                    width="45px"
                    heigth="15px"
                  />{" "}
                </Col>
                <Col xs={10} className="pl-0 f12-400 opacity5">
                  {`${orderData.payment_status === 1
                    ? "Your payment was sucessfull"
                    : orderData.payment_method === 6 &&
                      orderData?.payment_status === 0
                      ? "Payment needs to be settled before changing the status to complete"
                      : orderData?.payment_status === 0
                        ? "Your payment failed"
                        : "Your payment failed"
                    }`}
                </Col>
              </Row>
            </div>
            <hr />
            <div
              className="px-4 py-3 mb-3"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <div className="row">
                <div className="col-6 f11-400" style={{ color: "#717171" }}>
                  Transaction ID :{" "}
                  <span className="f11-500" style={{ color: "#F85032" }}>
                    {orderData?.transactional_id}
                  </span>
                </div>
              </div>
              <br />
              <Row>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("Do MMMM YYYY")}</>
                    ) : (
                      <>
                        {" "}
                        {moment(orderData.later_date).format(
                          "Do MMMM YYYY"
                        )}{" "}
                      </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Date
                  </p>
                </Col>
                <Col xs={6}>
                  <h5 className="f16-700">
                    {orderData.now ? (
                      <> {moment().format("hh:mm A")}</>
                    ) : (
                      <> {moment(orderData.later_date).format("hh:mm A")} </>
                    )}{" "}
                  </h5>
                  <p className="f10-400" style={{ color: "#757575" }}>
                    Time
                  </p>
                </Col>
              </Row>
            </div>
            <div className="px-4 py-3" style={{ backgroundColor: "#F3F3F3" }}>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f12-500 opacity5" style={{ width: "70%" }}>
                      Sub Total
                    </td>
                    <td className="f12-500 text-right" style={{ width: "30%" }}>
                      ₹{orderData.base_amount}
                    </td>
                  </tr>

                  <tr>
                    <td
                      className="f12-500 opacity5 pt-3 pb-3"
                      style={{ width: "70%" }}
                    >
                      Taxes
                    </td>
                    <td
                      className="f12-500 text-right pt-3 pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {orderData && orderData.gstAmount ? (
                        <>{calcTaxes(orderData.gstAmount)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Surcharges
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹
                      {orderData && orderData.surCharges ? (
                        <>{calcTaxes(orderData.surCharges)}</>
                      ) : (
                        <> </>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="d-flex align-items-center f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Tip&nbsp;&nbsp;
                      <VendorLearnMore
                        heading="Discount"
                        paragraphText="‘Loremmmmmmmm ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                      />
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹{" "}
                      {orderData && orderData.tip && orderData.tip.amount
                        ? orderData.tip.amount.toFixed(2)
                        : 0}
                      {/* {orderData?.tip?.amount || "0.00"} */}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 pb-3"
                      style={{ width: "70%" }}
                    >
                      Donation{" "}
                    </td>
                    <td
                      className="f12-500 text-right pb-3"
                      style={{ width: "30%" }}
                    >
                      ₹
                      {orderData &&
                        orderData.donation &&
                        orderData.donation.amount
                        ? orderData.donation.amount.toFixed(2)
                        : 0}
                      {/* {orderData.donation ? (
                        <>
                          {" "}
                          {orderData &&
                            orderData.donation &&
                            orderData.donation.amount}
                        </>
                      ) : (
                        "0.00"
                      )} */}
                    </td>
                  </tr>
                  <tr>
                    <td
                      className="f12-500 opacity5 d-flex align-items-center"
                      style={{ width: "70%" }}
                    >
                      Discount&nbsp;&nbsp;
                      <VendorLearnMore
                        heading="Discount"
                        paragraphText="‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy. ‘Lorem ipsum dolor sit amet, consectetur adipisici elit…’ (complete text) is dummy text that is not meant to mean anything. It is used as a placeholder in magazine layouts, for example, in order to give an impression of the finished document. The text is intentionally unintelligible so that the viewer is not distracted by the content. The language is not real Latin and even the first word ‘Lorem’ does not exist. It is said that the lorem ipsum text has been common among typesetters since the 16th century. (Source: Wikipedia.com). Unfortunately, we’re unable to offer free samples. As a retailer, we buy all magazines from their publishers at the regular trade price. However, you could contact the magazine’s publisher directly to ask if they can send you a free copy."
                      />
                    </td>
                    <td className="f12-500 text-right" style={{ width: "30%" }}>
                      {orderData &&
                        orderData.discount &&
                        orderData.discount.amount !== 0 ? (
                        <span
                          style={{
                            color: "#EE3A23",
                            fontSize: "19px",
                          }}
                        >
                          -
                        </span>
                      ) : (
                        ""
                      )}{" "}
                      ₹
                      {/* {orderData.discount ? (
                        <>
                          {" "} */}
                      {orderData &&
                        orderData.discount &&
                        orderData.discount.amount
                        ? orderData.discount.amount.toFixed(2)
                        : 0}
                      {/* {orderData &&
                            orderData.discount &&
                            orderData.discount.amount}{" "} */}
                      {/* </>
                      ) : (
                        "0.00"
                      )} */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="px-4 py-3 mb-5 border-top"
              style={{ backgroundColor: "#F3F3F3" }}
            >
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td className="f16-700" style={{ width: "70%" }}>
                      {orderData.payment_status !== 1
                        ? "Total Amount Paid"
                        : "Paid"}
                      {/* : "UnPaid"} */}
                    </td>
                    <td className="f16-700 text-right" style={{ width: "30%" }}>
                      ₹&nbsp;{orderData.total_amount}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <hr className="mb-0" />
            <div className="px-5 py-3" style={{ backgroundColor: "#FFFFFF" }}>
              <Button
                className="btn f18_500_HelveticaNeue py-3"
                style={{
                  backgroundColor: "#EE3A23",
                  width: "100%",
                  border: "none",
                }}
                type="button"
                title="Done"
                // onClick={() => {
                //   props.setOpenTract();
                // }}
                // onClick={() => history.push("/orderdashboard")}
                onClick={() => clearAndRedirect()}
              >
                Done
              </Button>
            </div>
            {/* <button
            type="button"
            class="onboarding_button_link_reusable onboarding_button_link_reusable_red w-100"
            title="Done"            
            onClick={() => clearAndRedirect()}
          >
            Done
          </button> */}
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  } catch (e) {
    return <> </>;
    console.log(e);
  }
};

const InputPromotion = (props) => {
  const classes = useStyles();

  const [offerCode, setOfferCode] = useState("");

  useEffect(() => {
    if (props && props.offer_code && props.offer_code.isOfferApplied) {
      setOfferCode(props.offer_code.coupon_code);
    }
  }, [props.offer_code.isOfferApplied]);

  const removeOffer = () => {
    const formData = {};
    formData.isOfferApplied = false;
    store.dispatch({
      type: APPLY_OFFER_VENDOR,
      payload: formData,
    });
  };

  return (
    <React.Fragment>
      <div>
        <Paper className={classes.root}>
          <InputBase
            disabled={
              props && props.offer_code && props.offer_code.isOfferApplied
            }
            className={classes.input}
            placeholder="Write Here"
            inputProps={{ "aria-label": "Write Here" }}
            value={offerCode.toUpperCase()}
            onChange={(e) => setOfferCode(e.currentTarget.value)}
          />
          <IconButton
            className={classes.iconButton}
            aria-label="apply"
            onClick={() => {
              if (offerCode === "") {
                Alert.error(`<h4>Enter Coupon Code</h4>`, {
                  position: "top-right",
                  effect: "bouncyflip",
                  beep: true,
                  html: true,
                  timeout: 3000,
                  offset: 35,
                });
              } else {
                props && props.offer_code && props.offer_code.isOfferApplied
                  ? removeOffer()
                  : props.apply_offer(offerCode);
              }
            }}
          >
            <button
              className="btn"
              style={{
                backgroundColor: "#2196F3",
                color: "#ffffff",
                borderRadius: "15px",
                boxShadow: "0px 5px 8px #6E6E6E57",
              }}
            >
              {props && props.offer_code && props.offer_code.isOfferApplied
                ? "Remove"
                : "Apply"}
            </button>
          </IconButton>
        </Paper>
      </div>
    </React.Fragment>
  );
};

const tips = [
  { id: 0, amount: 0, title: "None" },
  { id: 1, amount: 5, title: "5" },
  { id: 2, amount: 10, title: "10" },
  { id: 3, amount: 15, title: "15" },
  // { id: 4, title: "Custom" },
];

const donates = [
  { id: 0, amount: 0, title: "None" },
  { id: 1, amount: 2, title: "2" },
  { id: 2, amount: 5, title: "5" },
  { id: 3, amount: 10, title: "10" },
  // { id: 4, amount: 40 },
  // { id: 5, amount: 50 },
  // { id: 6, amount: 100 },
  // { id: 4, title: "Custom" },
];

const suggestions = [
  {
    id: 0,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 1,
    title: "7up (500ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
  {
    id: 2,
    title: "Pepsi (250ml)",
    type: 0,
    rating: 4.2,
    price: 450,
    best: true,
  },
];

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  subscription: state.onboarding.onboard_subscription_details,
  cart_data: state.vendorOrdering.vendor_cart_data,
  cart_data_two: state.vendorOrdering.vendor_cart_data,
  user_data: state.vendorOrdering.vendor_order_data,
  order_id: state.vendorOrdering.order_id,
  vendor_filtered_menu: state.vendorOrdering.vendor_filtered_menu,
  offerData: state.offersevents.vendor_all_offers,
});

// const mapDispathToProps = (dispatch) => ({
//   addTips: (tipamt) => {
//     dispatch({ type: SET_ORDER_TIP, id: tipamt });
//   },
//   // updateProduct: (id) => {
//   //   dispatch({ type: "UPDATE_PRODUCT", id: id });
//   // },
// });

export default withRouter(
  connect(mapStateToProps, {
    create_order_vedor_side,
    razor_pay_create_order,
    razor_payment,
    edit_order_vendor_side_payment,
    apply_offer_code,
    editTransaction,
  })(RightComponentOrderRequest)
);

// export default RightComponentOrderRequest;
